import CandidateNotesCard, { CandidateNotesCardProps } from './CandidateNotesCard.container';

export type CandidateNotesCardType = CandidateNotesCardProps;

export default CandidateNotesCard;
